import React from 'react'
import Segment from './segment';

const Radio = ({ content, diagnosis, onSelected }) => {
    let c = content;

    let checkforHtml = () => {
        if(c.text != null) {
            let newText = "" + c.text;
            if(newText.includes("<b>") || newText.includes("<i>") || newText.includes("<br>")) {
                return(<div dangerouslySetInnerHTML={({__html: c.text})}></div>)
            } else {
                return((c.text || []).map((l, i) => (
                    <React.Fragment key={i}>{l}{i < (c.text.length - 1) ? <br /> : ''}</React.Fragment>
                )))
            }
        } else {
            return((c.text || []).map((l, i) => (
                <React.Fragment key={i}>{l}{i < (c.text.length - 1) ? <br /> : ''}</React.Fragment>
            )))
        }
    }

    return (
        <div className='question-content'>
        <p>{c.text}</p>
            {c.groups ? c.groups.map((g) => {
                g.title = c.title;
                return (<Segment content={g} diagnosis={diagnosis} onSelected={onSelected} key={c.title + c.text} type={c.type} />)
            }) : ""}
        </div>)
};

export default Radio